
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"32","height":"32","viewBox":"0 0 32 32","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M14.1997 7.45452L5.28218 22.3416C5.09832 22.66 5.00104 23.0209 5.00001 23.3886C4.99898 23.7563 5.09424 24.1178 5.27631 24.4372C5.45838 24.7567 5.72092 25.0228 6.0378 25.2093C6.35469 25.3958 6.71487 25.496 7.08252 25.5H24.9175C25.2851 25.496 25.6453 25.3958 25.9622 25.2093C26.2791 25.0228 26.5416 24.7567 26.7237 24.4372C26.9058 24.1178 27.001 23.7563 27 23.3886C26.999 23.0209 26.9017 22.66 26.7178 22.3416L17.8003 7.45452C17.6127 7.1451 17.3484 6.88927 17.033 6.71173C16.7177 6.53418 16.3619 6.44091 16 6.44091C15.6381 6.44091 15.2823 6.53418 14.967 6.71173C14.6516 6.88927 14.3873 7.1451 14.1997 7.45452Z","stroke":"#10001F","stroke-width":"2","stroke-linecap":"round","stroke-linejoin":"round"}}),_c('path',{attrs:{"d":"M16 13.2886V17.4999","stroke":"#10001F","stroke-width":"2","stroke-linecap":"round","stroke-linejoin":"round"}}),_c('path',{attrs:{"d":"M16 21H16.011","stroke":"#10001F","stroke-width":"2","stroke-linecap":"round","stroke-linejoin":"round"}})])
          )
        }
      }
    